import FileMetaDTO from "@/dto/files/FileMetaDTO";
import PageFileDTO from "@/dto/files/PageFileDTO";

export default class FileSplitDTO {

    public originalFile!: FileMetaDTO;
    public pages!: Array<PageFileDTO>;

}
